const links = [
  { label: 'Home', redirect: '/', icon: 'user-circle' },
  { label: 'Schedules', redirect: '/leagues/schedules', icon: 'calendar' },
  { label: 'Leagues', redirect: '/leagues', icon: 'layer-group' },
  { label: 'Players', redirect: '/players', icon: 'users' },
  { label: 'Rules', redirect: '/rules', icon: 'gavel' },
  { label: 'Contact', redirect: '/contact', icon: 'address-card' }
]

export default links